import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59d6b4d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "cont-nav" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "list-block" }
const _hoisted_9 = { class: "list" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tip" }, " 注：当前行业中超过30%的个股发布了最新一期报告时进行数据统计。新股因未公布季报而不加入排名。 ", -1))
const _hoisted_12 = {
  key: 0,
  class: "coll-slot"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode("收起内容 ")
const _hoisted_14 = {
  key: 1,
  class: "coll-slot"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode("查看更多详细介绍 ")
const _hoisted_16 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_hydw_headline = _resolveComponent("hydw-headline")!
  const _component_Charts = _resolveComponent("Charts")!
  const _component_Table = _resolveComponent("Table")!
  const _component_DownOutlined = _resolveComponent("DownOutlined")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_hydw_headline, {
      class: "headline",
      onChangeReportDate: _ctx.changeReportDate,
      onChangeGrade: _ctx.changeGrade,
      theme: _ctx.theme,
      defaultReportDate: _ctx.defaultReportDate,
      reportDatas: _ctx.reportDatas
    }, null, 8, ["onChangeReportDate", "onChangeGrade", "theme", "defaultReportDate", "reportDatas"]),
    _createVNode(_component_a_spin, {
      tip: "加载中...",
      spinning: _ctx.spinning
    }, {
      default: _withCtx(() => [
        _createElementVNode("section", null, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h2", null, [
              _createTextVNode(_toDisplayString(_ctx.industryLevel === 1 ? '二级行业' : '三级行业') + "：", 1),
              _createElementVNode("span", null, _toDisplayString((_ctx.CompanyNumAndIndustryData||[]).FirstIndustryName), 1),
              ((_ctx.CompanyNumAndIndustryData||{}).SecondIndustryName)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, "- " + _toDisplayString((_ctx.CompanyNumAndIndustryData||{}).SecondIndustryName), 1))
                : _createCommentVNode("", true),
              ((_ctx.CompanyNumAndIndustryData||{}).ThirdIndustryName)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, "- " + _toDisplayString((_ctx.CompanyNumAndIndustryData||{}).ThirdIndustryName), 1))
                : _createCommentVNode("", true),
              ((_ctx.CompanyNumAndIndustryData||{}).CompanyNum)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, "（共" + _toDisplayString((_ctx.CompanyNumAndIndustryData||{}).CompanyNum) + "家）", 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("nav", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag, idx) => {
              return (_openBlock(), _createElementBlock("span", {
                key: tag.value,
                class: _normalizeClass({ active: tag.value === _ctx.activeTagVal }),
                onClick: ($event: any) => (_ctx.checkTag(tag.value,idx))
              }, _toDisplayString(tag.label), 11, _hoisted_6))
            }), 128))
          ]),
          ((_ctx.data || []).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("ul", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (tab) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: tab.val,
                        class: _normalizeClass({ active: _ctx.activelist == tab.val }),
                        onClick: ($event: any) => (_ctx.changList(tab.val))
                      }, _toDisplayString(tab.name), 11, _hoisted_10))
                    }), 128))
                  ]),
                  _createVNode(_component_Charts, {
                    id: "NumberofShareholders",
                    option: _ctx.option
                  }, null, 8, ["option"])
                ]),
                _hoisted_11,
                _createVNode(_component_a_collapse, {
                  activeKey: _ctx.activeKey,
                  "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeKey) = $event)),
                  accordion: "",
                  bordered: false,
                  "expand-icon-position": 'right'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_collapse_panel, {
                      key: "1",
                      forceRender: true
                    }, {
                      header: _withCtx(() => [
                        (_ctx.activeKey=='1')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _hoisted_13,
                              _createVNode(_component_DownOutlined, { rotate: 180 })
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              _hoisted_15,
                              _createVNode(_component_DownOutlined)
                            ]))
                      ]),
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_component_Table, {
                          ref: "mytable",
                          data: _ctx.data,
                          columns: _ctx.columns,
                          bordered: true,
                          pagination: _ctx.total>10 ? _ctx.pagination:false,
                          scroll: { x: '100%' },
                          key: _ctx.tableKey
                        }, null, 8, ["data", "columns", "pagination"]))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["activeKey"])
              ]))
            : (_openBlock(), _createElementBlock("section", _hoisted_16, [
                _createVNode(_component_Nodata, {
                  nodatadesc: _ctx.itemdata.title
                }, null, 8, ["nodatadesc"])
              ]))
        ])
      ]),
      _: 1
    }, 8, ["spinning"])
  ]))
}